__turbopack_context__.v({
  "code": "DemoContent-module__5IzRhq__code",
  "codeBlock": "DemoContent-module__5IzRhq__codeBlock",
  "codeSection": "DemoContent-module__5IzRhq__codeSection",
  "container": "DemoContent-module__5IzRhq__container",
  "demoSection": "DemoContent-module__5IzRhq__demoSection",
  "header": "DemoContent-module__5IzRhq__header",
  "headerActions": "DemoContent-module__5IzRhq__headerActions",
  "headerContainer": "DemoContent-module__5IzRhq__headerContainer",
  "switchContainer": "DemoContent-module__5IzRhq__switchContainer",
  "switchContainerHidden": "DemoContent-module__5IzRhq__switchContainerHidden",
  "tabContainer": "DemoContent-module__5IzRhq__tabContainer",
});
